import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader, Tooltip, Tag, Select, Input, Spin, message } from "antd";
import { EditOutlined, TableOutlined, ProjectOutlined, UserOutlined } from "@ant-design/icons";
import { ButtonItem, SegmentedItem, TableItemDinamico, SelectItem } from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import SelectContratoCMMS from "../componentes/SelectContratoCMMS";
import FiltroIngenieroCMMS, { esperarFiltroDefault } from "../componentes/FiltroIngenieroCMMS";
import { cmmsPost, TIPOS_SERVICIO, estatusServicio, estatusEquipo, formatoFechaHora } from "../cmmsComun";
import TableroServicios from "./TableroServicios";
import MisServicios from "./MisServicios";

const { Option } = Select;

// La vista elegida se recuerda en este navegador (comodidad, no dato del sistema).
const LLAVE_VISTA = "cmmsServiciosVista";
const vistaGuardada = () => {
    try {
        return localStorage.getItem(LLAVE_VISTA) || "tabla";
    } catch (e) {
        return "tabla";
    }
};

// Ordenes de Servicio (equivalente a la bitacora C-SE-01, sin capturar en Excel), en tabla,
// en tablero por estatus o como "Mis servicios" del ingeniero.
class Servicios extends Component {
    state = { loading: false, servicios: [], totalRecords: 0, valor: 1, tipoServicio: null, clienteId: null, empleadoId: null, contratoId: null, vista: vistaGuardada(), texto: "", listo: false };

    componentDidMount() {
        // Tabla y tablero arrancan con el ingeniero que fijó el usuario (si fijó uno).
        esperarFiltroDefault(this).then(() => this.setState({ listo: true }));
    }

    cambiarVista = (vista) => {
        try {
            localStorage.setItem(LLAVE_VISTA, vista);
        } catch (e) {
            // sin almacenamiento local: solo no se recuerda
        }
        this.tableRef = null;
        // La tabla se vuelve a montar: se le pasan los filtros de la cabecera.
        this.setState({ vista }, () => vista === "tabla" && setTimeout(() => this.aplicarFiltros({}), 0));
    };

    consultar = async (params) => {
        this.setState({ loading: true });
        try {
            // Los filtros de la cabecera siempre van (la tabla, al montarse, solo conoce los suyos).
            const { tipoServicio, clienteId, empleadoId, contratoId } = this.state;
            const res = await cmmsPost(this.props, "selectServiciosCMMS", { ...params, tipoServicio, clienteId, empleadoId, contratoId });
            if (res.data.success === 2) this.setState({ servicios: res.data.data, totalRecords: res.data.totalRecords });
            else this.setState({ servicios: [], totalRecords: 0 });
        } catch (error) {
            console.log(error);
            message.error("Error al consultar los servicios");
        } finally {
            this.setState({ loading: false });
        }
    };

    aplicarFiltros = (cambios) =>
        this.setState(cambios, () =>
            this.tableRef?.updateExternalFilters({
                ...(this.tableRef.state?.externalFilters || {}),
                valor: this.state.valor,
                tipoServicio: this.state.tipoServicio,
                clienteId: this.state.clienteId,
                empleadoId: this.state.empleadoId,
                contratoId: this.state.contratoId,
            })
        );

    abrir = (id) => this.props.history.push("/panel/cmmsServicio", { id });

    renderFiltros() {
        const { vista } = this.state;
        return (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, alignItems: "center", background: "white", padding: "8px 12px", marginBottom: 10, border: "1px solid rgb(235, 237, 240)" }}>
                {vista === "tablero" && (
                    <Input.Search placeholder="Buscar folio, equipo, serie..." allowClear style={{ width: 240 }} onSearch={(texto) => this.setState({ texto })} />
                )}
                <SelectItem placeholder="Todos los tipos" allowClear width={230} value={this.state.tipoServicio || undefined} onChange={(t) => this.aplicarFiltros({ tipoServicio: t || null })}>
                    {TIPOS_SERVICIO.map((t) => (
                        <Option key={t.value} value={t.value}>
                            {t.label}
                        </Option>
                    ))}
                </SelectItem>
                <div style={{ width: 260 }}>
                    <SelectClientesItem
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        placeholder="Todos los clientes"
                        allowClear
                        width="100%"
                        value={this.state.clienteId || undefined}
                        onChange={(clienteId) => this.aplicarFiltros({ clienteId: clienteId || null, contratoId: null })}
                    />
                </div>
                <div style={{ width: 240 }}>
                    <SelectContratoCMMS
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        clienteId={this.state.clienteId}
                        value={this.state.contratoId}
                        onChange={(contratoId) => this.aplicarFiltros({ contratoId })}
                    />
                </div>
                <FiltroIngenieroCMMS {...this.props} width={290} value={this.state.empleadoId} onChange={(empleadoId) => this.aplicarFiltros({ empleadoId })} />
            </div>
        );
    }

    renderTabla(columns) {
        return (
            <TableItemDinamico
                onRef={(ref) => (this.tableRef = ref)}
                totalRecords={this.state.totalRecords}
                anadirValorFiltro={this.state.valor}
                valorDefault={1}
                setValor={(valor) => this.setState({ valor })}
                setTextoFiltro={() => {}}
                onFetchData={this.consultar}
                loading={this.state.loading}
                size="small"
                dataSource={this.state.servicios}
                columns={columns}
                pagination={false}
                rowKey="_id"
                filterStorageKey={"ServiciosCMMSFiltrosTabla" + this.props.empresaId}
                onRow={(r) => ({ onDoubleClick: () => this.abrir(r._id) })}
            />
        );
    }

    render() {
        const { vista } = this.state;
        const columns = [
            { title: "Folio", dataIndex: "codigo", key: "codigo", buscar: "codigo", sorter: true, width: 120, render: (v, r) => (r.folioExterno ? <Tooltip title={`Folio externo ${r.folioExterno}`}>{v}</Tooltip> : v) },
            { title: "Tipo", dataIndex: "tipoServicio", key: "tipoServicio", sorter: true, width: 190, render: (v, r) => r.tipoServicioNombre },
            {
                title: "Estatus",
                dataIndex: "estatus",
                key: "estatus",
                sorter: true,
                width: 130,
                render: (v, r) =>
                    r.terminadoEnSitio && v !== 3 ? (
                        <Tag color="green" title="El ingeniero la terminó en sitio desde la app: revísela y concluya">
                            Terminada en sitio
                        </Tag>
                    ) : (
                        <Tag color={estatusServicio(v).color}>{estatusServicio(v).label}</Tag>
                    ),
            },
            { title: "Equipo", dataIndex: "activoTexto", key: "activoTexto", buscar: "activoTexto", width: 240, render: (v, r) => (r.activoId ? v : <Tag>Sin equipo</Tag>) },
            { title: "Cliente", dataIndex: "clienteNombre", key: "clienteNombre", buscar: "clienteNombre", width: 210 },
            { title: "Ingeniero", dataIndex: "empleadoNombre", key: "empleadoNombre", buscar: "empleadoNombre", width: 180 },
            { title: "Inicio", dataIndex: "fechaInicio", key: "fechaInicio", sorter: true, width: 150, render: (v) => formatoFechaHora(v) },
            { title: "Conclusión", dataIndex: "fechaConclusion", key: "fechaConclusion", sorter: true, width: 150, render: (v) => formatoFechaHora(v) },
            { title: "Entrega", dataIndex: "condicionesEntrega", key: "condicionesEntrega", width: 150, render: (v) => (v?.estatus ? <Tag color={estatusEquipo(v.estatus).color}>{estatusEquipo(v.estatus).label}</Tag> : "") },
            { title: "Refacciones", dataIndex: "totalPartes", key: "totalPartes", width: 100 },
            { title: "Monto", dataIndex: "montoTotal", key: "montoTotal", width: 110, render: (v) => (v ? `$${Number(v).toLocaleString("es-MX", { minimumFractionDigits: 2 })}` : "") },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                fixed: "right",
                align: "center",
                width: 80,
                onCell: () => ({ className: "acciones-sin-hover", style: { textAlign: "center", padding: "4px" } }),
                render: (value) => (
                    <Tooltip title="Abrir">
                        <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.abrir(value._id)} />
                    </Tooltip>
                ),
            },
        ];
        return (
            <>
                <PageHeader
                    title="Servicios"
                    subTitle="Órdenes de Servicio"
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                    extra={
                        <>
                            <SegmentedItem
                                options={[
                                    { label: <span><TableOutlined /> Tabla</span>, value: "tabla" },
                                    { label: <span><ProjectOutlined /> Tablero</span>, value: "tablero" },
                                    { label: <span><UserOutlined /> Mis servicios</span>, value: "mis" },
                                ]}
                                value={vista}
                                onChange={this.cambiarVista}
                            />
                            {vista === "tabla" && (
                                <SegmentedItem
                                    options={[
                                        { label: "Abiertos", value: 1 },
                                        { label: "Concluidos", value: 2 },
                                        { label: "Cancelados", value: 3 },
                                        { label: "Todos", value: 4 },
                                    ]}
                                    value={this.state.valor}
                                    onChange={(valor) => this.aplicarFiltros({ valor })}
                                />
                            )}
                            <ButtonItem type="primary" olivo className="botonAgregar" onClick={() => this.props.history.push("/panel/cmmsServicio", {})}>
                                Nuevo Servicio
                            </ButtonItem>
                        </>
                    }
                />
                {vista === "mis" ? (
                    <MisServicios {...this.props} />
                ) : !this.state.listo ? (
                    <Spin spinning style={{ display: "block", padding: 40 }} />
                ) : (
                    <>
                        {this.renderFiltros()}
                        {vista === "tablero" ? (
                            <TableroServicios
                                {...this.props}
                                filtros={{ tipoServicio: this.state.tipoServicio, clienteId: this.state.clienteId, contratoId: this.state.contratoId, empleadoId: this.state.empleadoId, texto: this.state.texto }}
                            />
                        ) : (
                            this.renderTabla(columns)
                        )}
                    </>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Servicios);
